import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "form", "input"]
  static values = { type: String }

  connect() {
    this.editing = false
  }

  edit(event) {
    if (event) event.preventDefault()
    if (!this.hasFormTarget) return
    this.displayTarget.classList.add("hidden")
    this.formTarget.classList.remove("hidden")
    const input = this.inputTargets[0]
    if (input) input.focus()
    this.editing = true
  }

  cancel(event) {
    if (event) event.preventDefault()
    if (!this.hasFormTarget) return
    this.formTarget.classList.add("hidden")
    this.displayTarget.classList.remove("hidden")
    this.editing = false
  }

  submitOnEnter(event) {
    if (event.key === "Enter") {
      if (event.target.tagName !== "TEXTAREA") {
        event.preventDefault()
        this.formTarget.requestSubmit()
      }
    } else if (event.key === "Escape") {
      this.cancel(event)
    }
  }

  async handleSubmit(event) {
    event.preventDefault()
    const form = this.formTarget
    const url = form.action
    const method = (form.method || "post").toUpperCase()
    const formData = new FormData(form)
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    try {
      const response = await fetch(url, {
        method,
        headers: {
          "X-CSRF-Token": token,
          "Accept": "text/vnd.turbo-stream.html, text/html, application/xhtml+xml"
        },
        body: formData,
        credentials: "same-origin"
      })
      const success = response.ok
      const detail = { success }
      const input = this.inputTargets[0]
      if (success && input) {
        let value
        if (input.type === "checkbox") {
          value = input.checked ? "Yes" : "No"
        } else if (input.tagName === "SELECT") {
          value = input.options[input.selectedIndex]?.text || input.value
        } else {
          value = input.value
        }
        const span = this.displayTarget.querySelector("[data-inline-field-display]")
        if (span) {
          if (this.typeValue === "currency" && value) {
            span.textContent = this.formatCurrency(parseFloat(value))
          } else {
            span.textContent = value || "—"
          }
        }
      }
      this.dispatch("submit-end", { detail })
      if (success) this.cancel()
    } catch (e) {
      this.dispatch("submit-end", { detail: { success: false } })
    }
  }

  formatCurrency(amount) {
    if (isNaN(amount)) return amount
    return new Intl.NumberFormat(undefined, { style: "currency", currency: "USD" }).format(amount)
  }
}
